import React from "react";
import { ReviewData } from "../../Components/Home/ReviewData";
import ReviewCard from "../../Components/Home/ReviewCard";

const Reviews = () => {
  return (
    <div className="p-4 max-w-7xl mx-auto">
      <h4 className="text-lg sm:text-xl md:text-2xl font-semibold mb-6">Customer Reviews</h4>

      <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {ReviewData?.map(review => <ReviewCard key={review.id} review={review} />)}
      </div>
    </div>
  );
};

export default Reviews;
